import React, { Fragment as Frag } from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import pluralize from 'pluralize'
import get from 'lodash/get'

import { Flipper, Flipped } from 'react-flip-toolkit'
import { INTENTS } from 'reducers/quoteReducers'

import Button from 'discada/dist/Button'
import Loading from 'discada/dist/Loading'

import { DirtyMask } from 'components/widgets/Dirty'
import PricingCard from 'components/VRP/PricingCard'

import {
  getIsKnownCustomerFromState,
  getRooftopId,
} from 'selectors/appStatusSelectors'

import {
  getQuoteDirty,
  getRebateSumForContractDetails,
  getIsGettingPrograms,
  getTradeEquity,
  getRebatesForVehicle,
  getAddsPrice,
  getQuoteValue,
  getBestProgram,
  showPaymentRange,
  getValidModes,
} from 'selectors/quoteSelectors'

import { addToPageState, toggleQueryValue } from 'actions/pageStateActions'

import { trackSection, trackReaction } from 'actions/quoteActions'
import { replacePageState } from 'actions/pageStateActions'
import { moneyShort } from 'utils'

import './Pricing.scss'

export function DealAdditionsPreso(props) {
  let {
    replacePageState,
    trackSection,
    vehicleId,
    quoteId,
    tradeEquity,
    additionsTotal,
    gettingPrograms,
    rebateSum,
    rebateCount,
    mode,
    zipcode,
    taxRate,
    showRange,
    showTaxRate,
    trackReaction,
    addToPageState,
    isKnownCustomer,
  } = props

  return (
    <div className="deal-additions">
      <h5>
        This estimated {mode === 'cash' ? 'price' : 'payment'} also
        includes&hellip;
      </h5>

      <Flipper className="deal-addition-blocks" flipKey={rebateCount}>
        <Flipped flipId="trade">
          <div className="deal-addition-block">
            <span>
              <strong>{moneyShort(tradeEquity)}</strong> of Trade Equity
            </span>{' '}
            <Button
              icon="car"
              size="small"
              rounded
              onClick={() => {
                addToPageState(
                  { mode, quoteAction: INTENTS.tradeAppraisal },
                  null,
                  true,
                )
                trackReaction(vehicleId, quoteId, INTENTS.tradeAppraisal)
              }}
            >
              Get an Instant Appraisal!
            </Button>
          </div>
        </Flipped>

        <Flipped flipId="extras">
          <div className="deal-addition-block">
            <span>
              <strong>{moneyShort(additionsTotal)}</strong> in Included Extras
            </span>
            <Button
              icon="plus"
              size="small"
              rounded
              onClick={() => {
                replacePageState({ showFandI: mode }, null, true)
                trackSection(vehicleId, quoteId, 'customer-fandi', true)
              }}
            >
              Browse more Extras
            </Button>
          </div>
        </Flipped>

        {rebateCount > 0 && (
          <Flipped flipId="rebates">
            <div className="deal-addition-block">
              {gettingPrograms ? (
                <span>--</span>
              ) : isKnownCustomer ? (
                <span>
                  <strong>{moneyShort(rebateSum)}</strong> in Applied Incentives
                </span>
              ) : (
                <span>
                  <strong>{rebateCount}</strong> Incentives Available
                </span>
              )}
              <Button
                icon="dollar-sign"
                size="small"
                rounded
                onClick={() => {
                  if (isKnownCustomer) {
                    replacePageState({ addRebate: mode }, null, true)
                    trackSection(vehicleId, quoteId, 'customer-rebates', true)
                  } else {
                    addToPageState(
                      { mode, quoteAction: INTENTS.getOTD },
                      null,
                      true,
                    )
                  }
                }}
              >
                See all {pluralize('Incentives', rebateCount)}
              </Button>
            </div>
          </Flipped>
        )}

        <Flipped flipId="taxes">
          <div className={c('deal-addition-block', { highlight: showRange })}>
            {gettingPrograms && <span>--</span>}

            {showRange && !gettingPrograms && (
              <span>
                Get <strong>Your Payments Now!</strong>
              </span>
            )}

            {!showRange && !gettingPrograms && (
              <span>
                {showTaxRate ? (
                  <Frag>
                    <strong>{taxRate}%</strong> State Tax for{' '}
                    <strong>{zipcode}</strong>
                    <small>Other taxes may apply. See Summary</small>
                  </Frag>
                ) : (
                  <Frag>
                    For zip code <strong>{zipcode}</strong>
                  </Frag>
                )}
              </span>
            )}
            <Button
              icon="map-marker-alt"
              size="small"
              rounded
              secondary
              onClick={() => {
                replacePageState(
                  { mode, quoteAction: INTENTS.getOTD },
                  null,
                  true,
                )
                trackSection(vehicleId, quoteId, 'customer-zip-code', true)
              }}
            >
              Set your Location
            </Button>
          </div>
        </Flipped>
      </Flipper>
    </div>
  )
}

export function PaymentDescription({ showRange }) {
  return (
    <div
      className={c('payment-description', {
        ranges: showRange,
        exacts: !showRange,
      })}
    >
      {showRange ? (
        <span>
          These payments are estimates. Click here to make them{' '}
          <strong>PERSONALIZED FOR YOU</strong>
        </span>
      ) : (
        <span>
          These are <strong>YOUR PERSONALIZED PAYMENTS!</strong> All Rebates,
          Taxes &amp; Fees included!
        </span>
      )}
    </div>
  )
}

export function Pricing(props) {
  let {
    vehicleId,
    quoteId,
    mode,
    mini,
    children,
    okModes,
    gettingPrograms,
  } = props

  return (
    <div className="vrp-pricing vrp-section" id="vrp-pricing-inner">
      <div
        className={c('vrp-pricing-pencil', {
          active: !!mode,
        })}
      >
        <DirtyMask {...props} />
        <div className="pricing-controls" id="pricing-controls">
          <div className="pricing-cards">
            {gettingPrograms ? (
              <Loading />
            ) : (
              Object.keys(okModes)
                .map(k => {
                  if (!okModes[k]) return null

                  let selected = mode === k

                  return (
                    <PricingCard
                      toggle
                      key={k}
                      vehicleId={vehicleId}
                      quoteId={quoteId}
                      mode={k}
                      selected={selected}
                      mini={mini || !selected}
                      showParams
                    />
                  )
                })
                .filter(x => x)
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}

function mapStateToProps(state, op) {
  let program = getBestProgram(state, op.vehicleId, op.quoteId, op.mode),
    taxRate = get(program, 'Tax.Sales.Rate', null),
    programsHaveTaxes = getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      'programsHaveTaxes',
    ),
    isKnownCustomer = getIsKnownCustomerFromState(state),
    showRange = showPaymentRange(state, op.vehicleId, op.quoteId),
    showTaxRate = programsHaveTaxes && taxRate > 0,
    okModes = getValidModes(state, op.vehicleId, op.quoteId)

  return {
    ...op,
    rooftopId: getRooftopId(state),
    dirty: getQuoteDirty(state, op.vehicleId, op.quoteId),
    zipcode: getQuoteValue(state, op.vehicleId, op.quoteId, 'customerZipCode'),
    showTaxRate,
    taxRate,
    program,
    okModes,
    isKnownCustomer,
    gettingPrograms: getIsGettingPrograms(state, op.vehicleId, op.quoteId),
    tradeEquity: getTradeEquity(state, op.vehicleId, op.quoteId),
    rebateSum: getRebateSumForContractDetails(
      state,
      op.vehicleId,
      op.quoteId,
      op.mode,
    ),
    rebateCount: getRebatesForVehicle(
      state,
      op.vehicleId,
      op.quoteId,
      op.mode,
      {
        customer: true,
      },
    ).length,
    additionsTotal: getAddsPrice(state, op.vehicleId, op.quoteId),
    showRange,
  }
}

export default connect(
  mapStateToProps,
  {
    addToPageState,
    replacePageState,
    trackSection,
    toggleQueryValue,
  },
)(Pricing)

export const DealAdditions = connect(
  mapStateToProps,
  {
    addToPageState,
    replacePageState,
    trackSection,
    trackReaction,
  },
)(DealAdditionsPreso)
